import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        defaultQuery: '=',
        filter: '=',
        companyUsers: '=',
        formCategories: '=',
        sites: '<'
    },
    template: `
        <form ng-submit="vm.applyFilter()" class="table-filters">
            <div class="form form-filter">
                <div class="fields">
                    <div class="row">
                        <label class="label">{{ 'filter.Form Access' | translate }}</label>
                        <div class="items">
                            <div class="items">
                                <div
                                    ng-dropdown-multiselect=""
                                    options="vm.multiFilter.formAccessSites.options"
                                    selected-model="vm.multiFilter.formAccessSites.model"
                                    extra-settings="vm.multiFilter.formAccessSites.settings"
                                    translation-texts="vm.filterTranslations"
                                    >
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'forms.Keyword' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.keyword" type="text" class="form-control">
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'forms.Author' | translate }}</label>
                        <div class="items">
                            <select ng-model="vm.filter.createdBy" class="form-control">
                                <option value=""></option>
                                <option ng-repeat="user in vm.companyUsers" value="{{ user.id }}">
                                    {{ user.displayName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <label class="label">{{ 'forms.Category' | translate }}</label>
                        <div class="items">
                            <select ng-model="vm.filter.categoryId" class="form-control">
                                <option value="">-</option>
                                <option ng-repeat-start="category in vm.formCategories" value="{{ category.id }}">{{ category.activeI18n.name }}</option>
                                <option ng-repeat-start="categoryChild1 in category.childCategories" value="{{ categoryChild1.id }}">&emsp;{{ categoryChild1.activeI18n.name }}</option>
                                <option ng-repeat-start="categoryChild2 in categoryChild1.childCategories" value="{{ categoryChild2.id }}">&emsp;&emsp;{{ categoryChild2.activeI18n.name }}</option>
                                <option ng-repeat-start="categoryChild3 in categoryChild2.childCategories" value="{{ categoryChild3.id }}">
                                    &emsp;&emsp;&emsp;{{ categoryChild3.activeI18n.name }}
                                </option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                                <option ng-repeat-end ng-hide="true"></option>
                            </select>
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'general.Reset' | translate }}"></li>
                    <li><input type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
        </form>
    `
})
export default class {
    constructor ($translate, lodash, SiteService, FilterService) {
        this.$translate = $translate;
        this.lodash = lodash;
        this.SiteService = SiteService;
        this.FilterService = FilterService;
    }

    $onInit () {
        this.filter.errors = {};
        this.initMultiFilter();
        this.filterTranslations = this.FilterService.getTranslations();
    }

    initMultiFilter () {
        const siteOptions = this.sites.map(site => {
            return {
                value: site.id,
                label: site.name
            };
        });

        this.multiFilter = {
            formAccessSites: {
                model: this.lodash.clone(siteOptions),
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: true,
                    showUncheckAll: true,
                    smartButtonMaxItems: 3,
                    smartButtonTextConverter: (itemText) => {
                        return itemText;
                    }
                }
            }
        };
        // this is used when filter is reset
        this.defaultMultiFilter = angular.copy(this.multiFilter);
    }

    applyFilter () {
        const formAccessSiteIds = !this.multiFilter.formAccessSites.model.length ? [-1] : this.multiFilter.formAccessSites.model.map(site => site.value);
        this.filter = this.lodash.assign(this.filter, { 'formAccessSiteIds[]': formAccessSiteIds });

        this.filter.errors = {};
        this.list.fetch({}, this.filter);
    }

    resetFilter () {
        this.multiFilter = angular.copy(this.defaultMultiFilter);
        this.filter = this.lodash.assign({}, this.defaultQuery);
        delete this.list.sort;
        this.list.fetch({}, this.defaultQuery);
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/filter/index.js